import React from 'react';
import { UserIcon, HomeIcon, BriefcaseIcon, SparklesIcon, ArrowRightIcon } from 'lucide-react';
export function ForWhom() {
  const audiences = [{
    emoji: '👴',
    icon: <UserIcon className="h-6 w-6" data-id="element-1031" />,
    title: 'Personas mayores',
    subtitle: '75 años o más',
    description: 'Ideal para quienes buscan complementar su pensión y mejorar su calidad de vida sin dejar su hogar.',
    highlight: 'Mejor pensión',
    color: 'from-[#2B5FD9] to-[#1E4BB8]',
    lightColor: 'bg-blue-50',
    borderColor: 'border-[#2B5FD9]/20'
  }, {
    emoji: '🏠',
    icon: <HomeIcon className="h-6 w-6" data-id="element-1032" />,
    title: 'Propietarios',
    subtitle: 'Vivienda en zona urbana',
    description: 'Debes ser dueño de una propiedad habitacional en una zona urbana consolidada de Chile.',
    highlight: 'Tu casa te paga',
    color: 'from-purple-600 to-purple-500',
    lightColor: 'bg-purple-50',
    borderColor: 'border-purple-600/20'
  }, {
    emoji: '💼',
    icon: <BriefcaseIcon className="h-6 w-6" data-id="element-1033" />,
    title: 'Sin deuda vigente',
    subtitle: 'Propiedad pagada',
    description: 'La propiedad debe estar libre de hipotecas o con una deuda muy baja que se pueda saldar.',
    highlight: 'Patrimonio libre',
    color: 'from-green-600 to-green-500',
    lightColor: 'bg-green-50',
    borderColor: 'border-green-600/20'
  }];
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="para-quien" className="py-12 md:py-24 bg-[#F8FAFC] relative overflow-hidden" data-id="element-1034">
      <div className="absolute top-0 right-0 w-72 h-72 bg-[#2B5FD9]/5 rounded-full blur-3xl" data-id="element-1035" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-purple-500/5 rounded-full blur-3xl" data-id="element-1036" />

      <div className="container mx-auto max-w-7xl px-4 relative z-10" data-id="element-1037">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16" data-id="element-1038">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#2B5FD9]/10 rounded-full mb-3 md:mb-4" data-id="element-1039">
            <SparklesIcon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1040" />
            <span className="text-sm font-semibold text-[#2B5FD9]" data-id="element-1041">
              Requisitos
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-[#0A1628]" data-id="element-1042">
            ¿Quiénes pueden postular?
          </h2>
          <p className="text-sm md:text-lg text-[#6B7280] max-w-2xl mx-auto" data-id="element-1043">
            Requisitos simples para acceder al modelo
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-1044">
          {audiences.map((audience, index) => <div key={index} className={`group bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-xl transition-all duration-300 border-2 ${audience.borderColor} hover:-translate-y-1`} data-id="element-1045">
              <div className="text-5xl md:text-6xl mb-4" data-id="element-1046">{audience.emoji}</div>
              <h3 className="text-xl md:text-2xl font-bold text-[#0A1628] mb-1" data-id="element-1047">
                {audience.title}
              </h3>
              <p className="text-sm text-[#6B7280] mb-4" data-id="element-1048">{audience.subtitle}</p>
              <p className="text-sm md:text-base text-[#6B7280] leading-relaxed mb-4" data-id="element-1049">
                {audience.description}
              </p>
              <div className={`${audience.lightColor} rounded-lg p-3`} data-id="element-1050">
                <p className={`text-sm font-semibold bg-gradient-to-r ${audience.color} bg-clip-text text-transparent`} data-id="element-1051">
                  {audience.highlight}
                </p>
              </div>
            </div>)}
        </div>

        {/* Key message */}
        <div className="bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-2xl p-6 md:p-10 text-center text-white" data-id="element-1052">
          <h3 className="text-xl md:text-2xl font-bold mb-3" data-id="element-1053">
            No es un préstamo
          </h3>
          <p className="text-base md:text-lg opacity-90 max-w-2xl mx-auto mb-6" data-id="element-1054">
            No estás pidiendo dinero prestado. Estás utilizando tu patrimonio
            acumulado para generar ingresos, sin endeudarte.
          </p>
          <button onClick={() => scrollToSection('simulador')} className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#2B5FD9] font-semibold rounded-xl hover:bg-gray-100 transition-colors" data-id="element-1055">
            <span data-id="element-1056">Verificar requisitos</span>
            <ArrowRightIcon className="h-4 w-4" data-id="element-1057" />
          </button>
        </div>
      </div>
    </section>;
}